import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, X, Clock } from 'lucide-react';

const RatingReminder = ({ onRateClick, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show reminder after 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    onDismiss && onDismiss();
  };

  const handleRateClick = () => {
    setIsVisible(false);
    onRateClick && onRateClick();
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          className="fixed bottom-4 left-4 right-4 z-40"
        >
          <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-2xl p-4 shadow-2xl border border-purple-500">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <Star className="w-5 h-5 text-white" />
                </div>
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-white font-semibold text-sm">
                    Rate Your Experience
                  </h3>
                  <div className="flex items-center gap-1 text-white text-xs opacity-80">
                    <Clock className="w-3 h-3" />
                    <span>Just completed</span>
                  </div>
                </div>
                <p className="text-white text-xs opacity-90 mb-3">
                  Help other clients by sharing your consultation experience
                </p>
                
                <div className="flex gap-2">
                  <button
                    onClick={handleRateClick}
                    className="flex-1 bg-white text-purple-600 py-2 px-3 rounded-xl font-medium text-xs hover:bg-gray-100 transition-colors flex items-center justify-center gap-1"
                  >
                    <Star className="w-3 h-3" />
                    Rate Now
                  </button>
                  <button
                    onClick={handleDismiss}
                    className="px-3 py-2 text-white text-xs opacity-80 hover:opacity-100 transition-opacity"
                  >
                    Later
                  </button>
                </div>
              </div>
              
              <button
                onClick={handleDismiss}
                className="flex-shrink-0 p-1 text-white opacity-60 hover:opacity-100 transition-opacity"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RatingReminder;
